import classNames from 'classnames';
import { ComponentProps } from 'react';
import $ from 'src/app/pages/Payment/features/PaymentUserDetails/PaymentUserDetails.module.scss';

export function RowLabel({ className, ...props }: ComponentProps<'div'>) {
    return <div className={classNames($.rowLabel, className)} {...props} />;
}
